import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const JourneyCard = ({ journey, onEdit, onView, onDelete }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case 'published':
        return 'bg-success/10 text-success';
      case 'draft':
        return 'bg-warning/10 text-warning';
      case 'archived':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getEngagementColor = (level) => {
    if (level >= 75) return 'text-success';
    if (level >= 50) return 'text-warning';
    return 'text-error';
  };

  const handleViewClick = () => {
    navigate(`/learning-trail-detail-view/${journey?.id}`);
  };

  return (
    <div className="bg-card rounded-lg shadow-sm overflow-hidden hover-lift transition-organic group">
      <div className="relative h-48 overflow-hidden">
        <Image
          src={journey?.thumbnail}
          alt={journey?.thumbnailAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-organic"
        />
        <div className="absolute top-3 right-3 flex items-center space-x-2">
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(journey?.status)}`}>
            {journey?.status?.charAt(0)?.toUpperCase() + journey?.status?.slice(1)}
          </span>
        </div>
        {journey?.engagementLevel > 0 && (
          <div className="absolute bottom-3 left-3 bg-background/90 backdrop-blur-sm px-3 py-1.5 rounded-full flex items-center space-x-2">
            <Icon name="TrendingUp" size={16} className={getEngagementColor(journey?.engagementLevel)} />
            <span className={`text-xs font-medium ${getEngagementColor(journey?.engagementLevel)}`}>
              {journey?.engagementLevel}% engaged
            </span>
          </div>
        )}
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-lg md:text-xl font-semibold text-foreground line-clamp-2 flex-1">
            {journey?.title}
          </h3>
        </div>

        <p className="text-sm text-muted-foreground line-clamp-3 mb-4">
          {journey?.description}
        </p>

        <div className="space-y-3 mb-4">
          <div className="flex items-center text-sm text-muted-foreground">
            <Icon name="Calendar" size={16} className="mr-2 text-primary" />
            <span>Created {journey?.createdDate}</span>
          </div>

          <div className="flex items-center text-sm text-muted-foreground">
            <Icon name="GraduationCap" size={16} className="mr-2 text-primary" />
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary">
              Min: {journey?.minGradeLevel || 'All Grades'}
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-4 p-3 bg-muted/50 rounded-lg">
          <div className="text-center">
            <p className="text-2xl font-bold text-foreground">{journey?.attempts}</p>
            <p className="text-xs text-muted-foreground">Attempts</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-success">{journey?.completions}</p>
            <p className="text-xs text-muted-foreground">Completed</p>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Eye"
            onClick={handleViewClick}
            className="flex-1"
          >
            View
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="Edit"
            onClick={() => onEdit(journey?.id)}
            className="flex-1"
          >
            Edit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default JourneyCard;